import React from 'react';
import CustomAppModal from '@Modules/core/components/modal/CustomModal';
import CustomReactTable from '@Modules/core/components/table/CustomReactTable';
import { ChakraComponents as CC } from '@Modules/core/lib/chakra';
import {
  AccountSetupDatatableMeta,
  IAccountSetupDatatable,
} from './AccountSetupDatatableHandlerMeta';

export default function AccountSetupDatatableHandler() {
  const editUsersModal = React.useRef<any>(null);
  const deleteUsersModal = React.useRef<any>(null);

  const data: IAccountSetupDatatable[] = [
    {
      hpxAccount: '1000B',
      account: '1000B',
      solde: '500',
      devise: 'fcfa-beac',
    },
  ];

  const handleEdit = (row: any) => {
    editUsersModal?.current?.onOpen();
  };

  // const handleDelete = (row: any) => {
  //   deleteUsersModal?.current?.onOpen();
  // };

  return (
    <>
      <CustomReactTable
        data={data}
        columns={AccountSetupDatatableMeta.columns(handleEdit)}
      />

      <CustomAppModal
        title="Editer Le Status des utilisateurs"
        ref={editUsersModal}
        actionBtnText="Editer"
        actionBtnClick={() => editUsersModal?.current?.onClose()}
      >
        Edit Form
      </CustomAppModal>

      <CustomAppModal
        title="Confirmer la suppression"
        ref={deleteUsersModal}
        actionBtnText="Supprimer"
        actionBtnClick={() => deleteUsersModal?.current?.onClose()}
      >
        <CC.Text>Voulez-vous vraiment supprimer ?</CC.Text>
      </CustomAppModal>
    </>
  );
}
